//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import React from 'react'

import { EthAddr } from '@shared/SchemaTypes'

export default function AdminApproveTransferSource(_props: {
  poolAddr: EthAddr
  poolName: string
}): React.ReactElement {
  throw new Error('TODOV5 Not implemented')

  // const { poolAddr, poolName } = props
  // const [amount, setAmount] = React.useState<string>('')
  // const [maxAmount, setMaxAmount] = React.useState<number>(0)
  // const [sourceAccounts, setSourceAccounts] = React.useState<string[]>(['---'])
  // const [sourceAccountAddr, setSourceAccountAddr] = React.useState<string | undefined>('---')
  // const [destinationAccounts, setDestinationAccounts] = React.useState<string[]>(['---'])
  // const [destinationAccountAddr, setDestinationAccountAddr] = React.useState<string | undefined>('---')
  // const nullPoolBaseOverviewCTO: PoolBaseOverviewCTO = {
  //   name: '---',
  //   chainConfigurationName: 'local',
  //   blockNumber: 0,
  //   creationBlock: 0,
  //   currencyLabel: '',
  //   timestamp: 0,
  //   timeOfDay: 0,
  //   dayNumber: 0,
  //   chainId: 0,
  //   totalOutstandingLoanPrincipal: '0',
  //   poolType: 1,
  //   poolAddr: '',
  //   liquidityAssetAddr: '',
  //   poolAdminAddr: '',
  //   poolControllerAddr: '',
  //   feeVaultAddr: '',
  //   withdrawControllerAddr: '',
  //   borrowerManagerAddr: '',
  //   borrowerWalletAddr: '',
  //   borrowerVaultAddr: '',
  //   maxCapacity: '0',
  //   liquidityTokenSymbol: '',
  // }
  // const fetchingPoolBaseOverviewCTO: PoolBaseOverviewCTO = {
  //   name: '--Fetching--',
  //   chainConfigurationName: 'local',
  //   blockNumber: 0,
  //   creationBlock: 0,

  //   timestamp: 0,
  //   timeOfDay: 0,
  //   dayNumber: 0,
  //   chainId: 0,
  //   totalOutstandingLoanPrincipal: '0',
  //   poolType: 1,
  //   poolAddr: '',
  //   liquidityAssetAddr: '',
  //   poolAdminAddr: '',
  //   poolControllerAddr: '',
  //   feeVaultAddr: '',
  //   withdrawControllerAddr: '',
  //   borrowerManagerAddr: '',
  //   borrowerWalletAddr: '',
  //   borrowerVaultAddr: '',
  //   maxCapacity: '0',
  //   liquidityTokenSymbol: '',
  //   currencyLabel: '',
  // }

  // const dispatch = useOtDispatch()
  // const { chainId, serverApiBaseUrl, restAPIKey, providerReadOnly, deploymentName, signer } =
  //   useOtChainStateUserConnection()

  // const chainTimestamp = useOtChainTimestamp()
  // const [destinationDeployment, setDestinationDeployment] = React.useState<string>(deploymentName)

  // const poolBaseOverviewCTO = useOtSelector((state) => state.poolState.poolOverviewCTOs[poolAddr ?? ETH_ADDR_ZERO])

  // const [destinationPools, setDestinationPools] = React.useState<PoolBaseConfigurationCTO[]>([nullPoolBaseOverviewCTO])
  // const [destinationPool, setDestinationPool] = React.useState<PoolBaseConfigurationCTO>(nullPoolBaseOverviewCTO)

  // const sourceDeployment = DEPLOYMENT_CONFIGURATIONS.find((config) => config.deploymentName === deploymentName)
  // const deployments = sourceDeployment?.deploymentSelections // DEPLOYMENT_CONFIGURATIONS.filter(
  // //    (d) => d.roleEnum === RoleEnum.TO_BE_DETERMINED || d.deploymentName === deploymentName
  // //).map((config: DeploymentConfiguration) => config.deploymentName)
  // const destinationDeploymentStruct = DEPLOYMENT_CONFIGURATIONS.find(
  //   (config: StageConfiguration) => config.deploymentName === destinationDeployment
  // )

  // useEffect(() => {
  //   if (poolAddr) {
  //     logOT.info(' fetchPools sourceAccountAddr', poolAddr)
  //     setSourceAccounts(['--Fetching--'])
  //     setSourceAccountAddr('--Fetching--')
  //     fetchPoolParticipants(serverApiBaseUrl, restAPIKey, poolAddr).then((result) => {
  //       setSourceAccounts(['---', ...result])
  //       setSourceAccountAddr('---')
  //     })
  //   }
  // }, [poolAddr])

  // useEffect(() => {
  //   logOT.info(' fetchPools destinationDeploymentStruct', destinationDeployment, destinationDeploymentStruct)
  //   if (destinationDeploymentStruct?.serverApiBaseUrl) {
  //     setDestinationPools([fetchingPoolBaseOverviewCTO])
  //     setDestinationPool(fetchingPoolBaseOverviewCTO)
  //     fetchPoolOverViews(destinationDeploymentStruct.serverApiBaseUrl, destinationDeploymentStruct.restAPIKey).then(
  //       (result) => {
  //         logOT.info(' fetchPools destinationDeploymentStruct', destinationDeploymentStruct)
  //         logOT.info('#fetchPoolOverViews ', result)
  //         let poolTypeMatched: Array<PoolOverviewCTO | PoolFlexOverviewCTO> = result.filter(
  //           (pool) => pool.poolType === poolBaseOverviewCTO?.poolType || pool.poolType === PoolTypeEnum.Dynamic
  //         )
  //         if (poolBaseOverviewCTO?.poolType === PoolTypeEnum.Term) {
  //           poolTypeMatched = poolTypeMatched.filter(
  //             (pool) =>
  //               pool.poolType === PoolTypeEnum.Dynamic ||
  //               ((pool as PoolOverviewCTO).activeLoanState?.loanAddr &&
  //                 (pool as PoolOverviewCTO).activeLoanState?.loanAddr !== ETH_ADDR_ZERO)
  //           )
  //         }

  //         logOT.info(' poolTypeMatched ', poolTypeMatched)
  //         setDestinationPools([nullPoolBaseOverviewCTO, ...poolTypeMatched])
  //         setDestinationPool(nullPoolBaseOverviewCTO)
  //       }
  //     )
  //   } else {
  //     setDestinationPools([nullPoolBaseOverviewCTO])
  //     setDestinationPool(nullPoolBaseOverviewCTO)
  //   }
  // }, [destinationDeployment])

  // useEffect(() => {
  //   setDestinationAccountAddr('--Fetching--')
  //   setDestinationAccounts(['--Fetching--'])

  //   const destinationPoolAddr = destinationPool?.poolAddr
  //   if (destinationDeploymentStruct && destinationPoolAddr) {
  //     fetchPoolParticipants(
  //       destinationDeploymentStruct.serverApiBaseUrl,
  //       destinationDeploymentStruct.restAPIKey,
  //       destinationPoolAddr
  //     ).then((result) => {
  //       setDestinationAccounts(['---', ...result])
  //       setDestinationAccountAddr('---')
  //     })
  //   } else {
  //     setDestinationAccounts(['---'])
  //     setDestinationAccountAddr('---')
  //   }
  // }, [destinationPool])
  // const handleSourceAccountAddrChangeAsync = async (event: SelectChangeEvent): Promise<void> => {
  //   const accountAddr = event.target.value
  //   setSourceAccountAddr(accountAddr)
  //   const poolAccountCTO = await fetchPoolAccountCTO(serverApiBaseUrl, restAPIKey, poolAddr, accountAddr)

  //   let _amount = '0'
  //   if (poolBaseOverviewCTO.poolType === PoolTypeEnum.Term) {
  //     _amount = poolAccountCTO?.principalEarningInterest ?? '0'
  //   } else {
  //     _amount = poolAccountCTO?.maxWithdrawRequest ?? '0'
  //   }
  //   setAmount(fromWeiToMWeiERC20DecString(_amount as ERC20Wei))
  //   setMaxAmount(Number(_amount) / 1_000_000)
  // }

  // const handleSourceAccountAddrChange = (event: SelectChangeEvent): void => {
  //   if (poolBaseOverviewCTO) {
  //     handleSourceAccountAddrChangeAsync(event).catch((e) => {
  //       logOT.error('handleSourceAccountAddrChange', e)
  //     })
  //   }
  // }

  // const handleDestinationDeploymentyChange = (event: SelectChangeEvent): void => {
  //   setDestinationDeployment(event.target.value)
  // }

  // const handleDestinationPoolChange = (event: SelectChangeEvent): void => {
  //   const pool = destinationPools.find((p) => p.name === event.target.value)
  //   if (pool) {
  //     setDestinationPool(pool)
  //   }
  // }

  // const handleCancel = (): void => {
  //   const event = new Event('modalClose')
  //   window.dispatchEvent(event)
  // }
  // const amountError = Number(amount) > maxAmount || isNaN(Number(amount))
  // const disableButton =
  //   amount.length === 0 ||
  //   destinationAccountAddr === '---' ||
  //   sourceAccountAddr === '---' ||
  //   destinationPool === nullPoolBaseOverviewCTO ||
  //   amountError
  // const handleOnChangeAmount = (e: any): void => {
  //   setAmount(e.target.value)
  // }

  // const handleTransferRequest = (): void => {
  //   logOT.debug('AdminApproveTransferSource handleTransferRequest')

  //   updatePoolCrossChainTransfer()
  //     .then(() => {
  //       logOT.info('CLOSE MODAL')
  //       const event = new Event('modalClose')
  //       window.dispatchEvent(event)
  //     })
  //     .catch((e) => {
  //       logOT.error('updatePoolCrossChainTransfer', e)
  //     })

  //   async function updatePoolCrossChainTransfer() {
  //     logOT.info(
  //       'AdminApproveTransferSource updatePoolCrossChainTransfer',
  //       sourceAccountAddr,
  //       destinationAccountAddr,
  //       destinationDeploymentStruct
  //     )

  //     const destinationServerApiBaseUrl = destinationDeploymentStruct?.serverApiBaseUrl
  //     if (destinationServerApiBaseUrl && sourceAccountAddr && destinationAccountAddr) {
  //       const poolCrossChainTransferCTO: PoolCrossChainTransferCTO = {
  //         poolAddr,
  //         amount: Math.round(Number(amount) * 1e6),
  //         timestamp: chainTimestamp,
  //         sourcePoolAddr: poolAddr,
  //         sourceChainId: chainId,
  //         sourceDeploymentName: deploymentName,
  //         sourceWalletAddr: sourceAccountAddr,
  //         destinationPoolAddr: destinationPool.poolAddr,
  //         destinationChainId: destinationDeploymentStruct?.chainId,
  //         destinationDeploymentName: destinationDeployment,
  //         destinationWalletAddr: destinationAccountAddr,
  //         transferStep: TransferStepNumbers.Source_Approval_Pending,
  //         transferStepName: TransferStepNames.Source_Approval_Pending,
  //       }

  //       logOT.info('AdminApproveTransferSource updatePoolCrossChainTransfer', poolCrossChainTransferCTO)

  //       await poolCrossChainTransferPut(
  //         serverApiBaseUrl,
  //         restAPIKey,
  //         destinationServerApiBaseUrl,
  //         destinationDeploymentStruct.restAPIKey,
  //         poolCrossChainTransferCTO
  //       )

  //       try {
  //         if (poolBaseOverviewCTO?.poolType === PoolTypeEnum.Term) {
  //           const poolControllerAddr = poolBaseOverviewCTO?.poolControllerAddr
  //           if (poolControllerAddr && signer) {
  //             const poolController = new ethers.Contract(poolControllerAddr, PoolControllerAbi, signer)

  //             const tx = await (
  //               poolController.connect(signer) as unknown as PoolController
  //             ).crossChainTransferApproveSource(
  //               destinationDeploymentStruct.chainId,
  //               poolAddr,
  //               destinationAccountAddr,
  //               sourceAccountAddr,
  //               BigInt(Math.round(Number(amount) * 1e6))
  //             )
  //             await tx.wait(1)
  //           } else {
  //             throw new Error('poolControllerAddr or signer is undefined')
  //           }
  //         } else {
  //           logOT.info('Execute Flex Transfer', poolAddr)
  //           const poolFlex = poolBaseOverviewCTO as PoolFlexOverviewCTO

  //           const poolControllerAddr = poolFlex.poolControllerAddr

  //           logOT.info('Execute Flex Transfer', poolControllerAddr, poolControllerAddr, amount)

  //           if (poolControllerAddr && signer) {
  //             const poolController = new ethers.Contract(poolControllerAddr, PoolControllerFlexAbi, providerReadOnly)

  //             logOT.info(
  //               'Execute Flex Transfer',
  //               destinationDeploymentStruct.chainId,
  //               poolAddr,
  //               destinationAccountAddr,
  //               sourceAccountAddr,
  //               BigInt(Number(amount) * 1e6)
  //             )

  //             const settings = await poolController.settings()
  //             logOT.info('settings', settings)
  //             const tx = await (
  //               poolController.connect(signer) as unknown as PoolControllerFlex
  //             ).crossChainTransferApproveSource(
  //               destinationDeploymentStruct.chainId,
  //               poolAddr,
  //               destinationAccountAddr,
  //               sourceAccountAddr,
  //               BigInt(Number(amount) * 1e6)
  //             )
  //             await tx.wait(0)
  //           } else {
  //             throw new Error('poolControllerAddr or signer is undefined')
  //           }
  //         }
  //       } catch (e: any) {
  //         logOT.info(
  //           'Execute Flex Transfer',
  //           e.code,
  //           e.shortMessage,
  //           e.message,
  //           e.transaction,
  //           e.info,
  //           Object.keys(e),
  //           Object.values(e)
  //         )
  //         const alertCTO: AlertCTO = alertCTOFromError(e, ActivityEnum.ChainTransfer)
  //         dispatch(alertActions.addAlert(alertCTO))
  //         throw e
  //       }

  //       poolCrossChainTransferCTO.transferStep = TransferStepNumbers.Source_Approved
  //       poolCrossChainTransferCTO.transferStepName = TransferStepNames.Source_Approved

  //       await poolCrossChainTransferPut(
  //         serverApiBaseUrl,
  //         restAPIKey,
  //         destinationServerApiBaseUrl,
  //         destinationDeploymentStruct.restAPIKey,
  //         poolCrossChainTransferCTO
  //       )
  //     }
  //   }
  // }

  // return (
  //   <Box py={2} px={2} width={500}>
  //     <Grid container spacing={6}>
  //       <Grid item xs={6}>
  //         <Typography sx={{ color: '#666' }} variant="h6">
  //           Source Chain ID
  //         </Typography>
  //         <Typography sx={{ fontWeight: 'bold' }} variant="small">
  //           {chainId}
  //         </Typography>
  //       </Grid>
  //       <Grid item xs={6}>
  //         <Typography sx={{ color: '#666' }} variant="h6">
  //           Source Vault Address
  //         </Typography>
  //         <AddressPill addr={poolAddr} />
  //       </Grid>
  //       <Grid item xs={6}>
  //         <Typography sx={{ color: '#666' }} variant="h6">
  //           Source Vault Name
  //         </Typography>
  //         <Typography sx={{ fontWeight: 'bold' }} variant="small">
  //           {poolName}
  //         </Typography>
  //       </Grid>
  //       <Grid item xs={6}>
  //         <InputLabel id="Source Account">Source Account</InputLabel>
  //         <Select
  //           style={{ width: '98%', height: '50%' }}
  //           labelId="asset-label"
  //           id="asset-select"
  //           input={<OutlinedInput id="asset-select" label="Asset" />}
  //           value={sourceAccountAddr}
  //           renderValue={(value: string) => {
  //             return (
  //               <Typography sx={{ marginLeft: 2 }} variant="bodyBold">
  //                 {value}
  //               </Typography>
  //             )
  //           }}
  //           onChange={handleSourceAccountAddrChange}
  //         >
  //           {sourceAccounts.map((addr: string) => (
  //             <MenuItem
  //               value={addr}
  //               key={addr}
  //               style={{
  //                 paddingLeft: 12,
  //                 display: 'flex',
  //                 flexDirection: 'row',
  //                 justifyContent: 'flex-start',
  //                 alignItems: 'center',
  //               }}
  //             >
  //               <Typography sx={{ marginLeft: 2 }} variant="bodyBold">
  //                 {addr}
  //               </Typography>
  //             </MenuItem>
  //           ))}
  //         </Select>
  //       </Grid>
  //       <Grid sx={{ marginTop: 1 }} item xs={12}>
  //         <SectionHeader>Destination</SectionHeader>
  //       </Grid>
  //       <Grid item xs={6}>
  //         <InputLabel id="DestinationId">Destination Deployment</InputLabel>
  //         <Select
  //           style={{ width: '98%', height: '50%' }}
  //           labelId="dest-chain-label"
  //           id="dest-chain-select"
  //           disabled={destinationPool?.name === '--Fetching--'}
  //           input={<OutlinedInput id="dest-chain-label" label="ChainId" />}
  //           value={destinationDeployment}
  //           renderValue={(value: string) => {
  //             return (
  //               <Typography sx={{ marginLeft: 2 }} variant="bodyBold">
  //                 {value}
  //               </Typography>
  //             )
  //           }}
  //           onChange={handleDestinationDeploymentyChange}
  //         >
  //           {deployments?.map((deployment: string) => (
  //             <MenuItem
  //               value={deployment}
  //               key={deployment}
  //               style={{
  //                 paddingLeft: 12,
  //                 display: 'flex',
  //                 flexDirection: 'row',
  //                 justifyContent: 'flex-start',
  //                 alignItems: 'center',
  //               }}
  //             >
  //               <Typography sx={{ marginLeft: 2 }} variant="bodyBold">
  //                 {deployment}
  //               </Typography>
  //             </MenuItem>
  //           ))}
  //         </Select>
  //       </Grid>
  //       <Grid item xs={6}>
  //         <Typography sx={{ color: '#666' }} variant="h6">
  //           Destination Chain ID
  //         </Typography>
  //         <Typography sx={{ fontWeight: 'bold' }} variant="small">
  //           {destinationDeploymentStruct?.chainId}
  //         </Typography>
  //       </Grid>
  //       <Grid item xs={6}>
  //         <InputLabel id="DestinationId">Destination Pool</InputLabel>
  //         <Select
  //           style={{ width: 250, height: '50%' }}
  //           labelId="dest-pool-label"
  //           id="asset-select"
  //           input={<OutlinedInput id="dest-pool-label" label="Destination Pool" />}
  //           value={destinationPool.name}
  //           renderValue={(value: string) => {
  //             return (
  //               <Typography sx={{ marginLeft: 2 }} variant="bodyBold">
  //                 {value}
  //               </Typography>
  //             )
  //           }}
  //           onChange={handleDestinationPoolChange}
  //         >
  //           {destinationPools.map((pool: PoolBaseConfigurationCTO) => (
  //             <MenuItem
  //               value={pool.name}
  //               key={pool.name}
  //               style={{
  //                 paddingLeft: 12,
  //                 display: 'flex',
  //                 flexDirection: 'row',
  //                 justifyContent: 'flex-start',
  //                 alignItems: 'center',
  //               }}
  //             >
  //               <Typography sx={{ marginLeft: 2 }} variant="bodyBold">
  //                 {pool.name}
  //               </Typography>
  //             </MenuItem>
  //           ))}
  //         </Select>
  //       </Grid>

  //       <Grid item xs={6}>
  //         <InputLabel id="Destination Account">Destination Account</InputLabel>
  //         <Select
  //           style={{ width: 250, height: '50%' }}
  //           labelId="asset-label"
  //           id="dest-account-select"
  //           input={<OutlinedInput id="dest-account-select" label="Asset" />}
  //           value={destinationAccountAddr}
  //           renderValue={(value: string) => {
  //             return (
  //               <Typography sx={{ marginLeft: 2 }} variant="bodyBold">
  //                 {value}
  //               </Typography>
  //             )
  //           }}
  //           onChange={(event: SelectChangeEvent) => {
  //             setDestinationAccountAddr(event.target.value as string)
  //           }}
  //         >
  //           {destinationAccounts.map((addr: string) => (
  //             <MenuItem
  //               value={addr}
  //               key={addr}
  //               style={{
  //                 paddingLeft: 12,
  //                 display: 'flex',
  //                 flexDirection: 'row',
  //                 justifyContent: 'flex-start',
  //                 alignItems: 'center',
  //               }}
  //             >
  //               <Typography sx={{ marginLeft: 2 }} variant="bodyBold">
  //                 {addr}
  //               </Typography>
  //             </MenuItem>
  //           ))}
  //         </Select>
  //       </Grid>

  //       <Grid item xs={12}>
  //         <InputLabel htmlFor="amount">Amount({poolBaseOverviewCTO?.liquidityTokenSymbol})</InputLabel>
  //         <TextField
  //           id="amount"
  //           InputProps={{
  //             endAdornment: <InputAdornment position="start">{poolBaseOverviewCTO?.curreliquidityTokenSymbolncyLabel}</InputAdornment>,
  //           }}
  //           inputProps={{
  //             'data-testid': 'amount',
  //           }}
  //           sx={{ width: '300px', height: '50%' }}
  //           variant="outlined"
  //           placeholder="Enter Transfer Amount"
  //           value={amount}
  //           type={'tel'}
  //           onChange={handleOnChangeAmount}
  //           error={amountError}
  //         />
  //         {amountError && (
  //           <Typography variant="inherit" color="textSecondary">
  //             {`Max Amount: ${maxAmount}`}
  //           </Typography>
  //         )}
  //       </Grid>

  //       <Grid item xs={12} sm={12}>
  //         <ButtonAction
  //           data-testid={'TransferRequest'}
  //           disabled={disableButton}
  //           sx={{ marginRight: '16px' }}
  //           variant={'primary'}
  //           onClick={handleTransferRequest}
  //         >
  //           Transfer Request
  //         </ButtonAction>

  //         <ButtonAction variant={'tertiary'} onClick={handleCancel}>
  //           Cancel
  //         </ButtonAction>
  //       </Grid>
  //     </Grid>
  //   </Box>
  // )
}
